export const buttonColorOptions = [
    "white",
    "productLinkFocus",
    "gray",
    "purple",
    "precisionBlue",
];

export const buttonColorOrderGrayBackground = [
    "purple",
    "precisionBlue",
    "productLinkFocus",
];

export const buttonColorOrderImageHero = [
    "white",
    "precisionBlue",
    "productLinkFocus",
];

export const buttonColorOrderImageHeroDark = [
    "white",
    "purple",
    "precisionBlue",
];

export const buttonColorOrderImageHeroEmber = [
    "productLinkFocus",
    "precisionBlue",
    "purple",
];

export const buttonColorDefault = "purple";
